// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"204128ba","931":"4d12f18c"}[chunkId] + ".chunk.js";
};